/**
 * Breakpoint width (in pixels) below which a device is considered mobile.
 */
const MOBILE_BREAKPOINT_WIDTH = 960;

/**
 * Detects if the user is on a mobile device for C2 tracking purposes.
 *
 * Uses two detection methods with OR logic - either condition being true
 * classifies the device as mobile:
 * 1. Screen width check: Catches desktop browsers in narrow windows and
 *    mobile devices that may spoof their user agent.
 * 2. User agent check: Catches mobile devices even when displayed in
 *    landscape mode or on tablets with larger screens.
 *
 * This inclusive approach ensures we don't miss mobile users, which is
 * preferred for tracking purposes where false positives are acceptable.
 *
 * @returns {boolean} true if the user is on a mobile device
 */
export const isMobileDevice = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  // Check screen width (mobile typically < MOBILE_BREAKPOINT_WIDTH)
  const isMobileWidth = window.innerWidth < MOBILE_BREAKPOINT_WIDTH;

  // Check user agent for mobile devices
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileUserAgent = mobileRegex.test(navigator.userAgent);

  return isMobileWidth || isMobileUserAgent;
};

export default isMobileDevice;
